function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "gg:check-o"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M10.243 16.8141L6 12.5701L7.414 11.1561L10.243 13.9841L15.899 8.32715L17.314 9.74215L10.243 16.8141Z",
  fill: "#1E2022"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 12.5C1 6.425 5.925 1.5 12 1.5C18.075 1.5 23 6.425 23 12.5C23 18.575 18.075 23.5 12 23.5C5.925 23.5 1 18.575 1 12.5ZM12 21.5C10.8181 21.5 9.64778 21.2672 8.55585 20.8149C7.46392 20.3626 6.47177 19.6997 5.63604 18.864C4.80031 18.0282 4.13738 17.0361 3.68508 15.9442C3.23279 14.8522 3 13.6819 3 12.5C3 11.3181 3.23279 10.1478 3.68508 9.05585C4.13738 7.96392 4.80031 6.97177 5.63604 6.13604C6.47177 5.30031 7.46392 4.63738 8.55585 4.18508C9.64778 3.73279 10.8181 3.5 12 3.5C14.3869 3.5 16.6761 4.44821 18.364 6.13604C20.0518 7.82387 21 10.1131 21 12.5C21 14.8869 20.0518 17.1761 18.364 18.864C16.6761 20.5518 14.3869 21.5 12 21.5Z",
  fill: "#1E2022"
})));

function SvgGgCheckO({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGgCheckO);
export default __webpack_public_path__ + "static/media/gg_check-o.2a51f648e043f32ae46fc938a6294a7d.svg";
export { ForwardRef as ReactComponent };